import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Intro from './components/Intro';
import PlotSection from './components/PlotSection';
import Characters from './components/Characters';
import UncutDetails from './components/UncutDetails';
import Highlights from './components/Highlights';
import Recommendations from './components/Recommendations';
import Themes from './components/Themes';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <PlotSection />
        <Characters />
        <UncutDetails />
        <Highlights />
        <Recommendations />
        <Themes />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}